import React from 'react';

interface IProps {
  id?: number;
  text?: string;
  fontSize: string;
  scale?: number;
  points?: Julius.Website.SectionPointViewModel[];
  onClick?: (sectionID: number) => void;
  isSelected?: boolean;
  isAvailable: boolean;
}

const pointToString = (
  point: { x: number; y: number },
  config: { scale: number } = { scale: 1 },
) => `${ point.x * config.scale } ${ point.y * config.scale }`;

const generateSVGPath = (
  points: Array<{ x: number; y: number }>,
  config: {
    scale?: number;
    color?: string;
    key?: string | number;
    onClick?: () => void;
  } = { scale: 1 },
) => {
  const { scale } = config;
  let pathData = `M${ pointToString(points[0], { scale }) } `;
  points.slice(1).forEach((p: { x: number; y: number }) => {
    pathData += `L${ pointToString(p, { scale }) } `;
  });
  pathData += `Z`;
  return pathData;
};

class SectionPaths extends React.PureComponent<IProps> {
  static defaultProps: Partial<IProps> = {
    scale: 1,
  }
  
  pathData = () => {
    const { points, scale } = this.props;
    return generateSVGPath(points, { scale });
  }

  getArea = () => {
    let i;
    let j;
    let point1;
    let point2;
    let area = 0;

    const { points, points: { length } } = this.props;

    for (i = 0, j = length - 1; i < length; j = i, i += 1) {
      point1 = points[i];
      point2 = points[j];
      area += point1.x * point2.y;
      area -= point1.y * point2.x;
    }
    area /= 2;
    return area;
  }
  
  getCenterPoint = () => {
    let x = 0;
    let y = 0;
    let i;
    let j;
    let f;
    let point1;
    let point2;

    const { scale, points, points: { length } } = this.props;

    for (i = 0, j = length - 1; i < length; j = i, i += 1) {
      point1 = points[i];
      point2 = points[j];
      f = point1.x * point2.y - point2.x * point1.y;
      x += (point1.x + point2.x) * f;
      y += (point1.y + point2.y) * f;
    }

    f = this.getArea() * 6;
    return { x: x / f * scale, y: y / f * scale };
  }
  
  render() {
    const { pathData } = this;
    const { id, text, isSelected, isAvailable, fontSize, onClick } = this.props;
    const fillColor = isSelected ? 'yellow': isAvailable ? 'white' : '#ccc';
    const center = this.getCenterPoint();
    
    return (
      <>
        <path
          d={ pathData() }
          fill={ fillColor }
          stroke="black"
          onClick={ isAvailable ? () => onClick(id) : undefined }
          style={ isAvailable ? { cursor: "pointer" } : undefined }
        />
      </>
    );
  }
}

export default SectionPaths;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/SectionOverview/SectionPaths.tsx